import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'

interface CourseRequirementsProps {
	courseRequirements: string[];
}

export const CourseRequirementsPreview = ({ courseRequirements }: CourseRequirementsProps) => {
	if (!courseRequirements?.length || courseRequirements.length === 1) {
		return null
	}
	return (
		<Box>
			<Typography
				sx={{
					fontSize: '24px',
					fontWeight: 800,
					color: '#000',
					marginTop: '64px',
					marginBottom: '14px'
				}}
			>
				Требования к курсу
			</Typography>
			<List>
				{courseRequirements.map((requirement: any, index: any) => (
					<ListItem key={index} sx={{
						display: 'flex',
						alignItems: 'center'
					}}>
						•
						<ListItemText
							primary={requirement}
							sx={{
								fontSize: '18px',
								fontWeight: 400,
								color: '#000',
								paddingLeft: '8px'
							}}
						/>
					</ListItem>
				))}
			</List>
		</Box>
	)
}
